import { forgotRequest, passwordRequest } from 'core/services/authentication';
import { useEffect, useRef, useState } from 'react';
import PrimaryButton from 'app/components/Button/PrimaryButton';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { validateEmail } from 'utils/validateEmail';
import { IPasswordToken } from 'core/slices/session';
import { SavingState } from 'types/domain/base';
import { LoadingSpinner } from '../Loading/loadingspinner';
import { ISessionReducer } from 'core/slices/session';
import { useSelector } from 'react-redux';
import { selectSession } from 'core/selectors/product/session';
import InputField from '../InputField';
import TextInput from '../InputField/textInput';

export function ForgotPassword() {
  const dispatch = useAppDispatch();
  const params = useParams();
  const [email, setEmail] = useState('');
  const [invalid, setInvalid] = useState(false);
  const token = useRef(params.token || `${new Date().getTime()}`);
  const passwordToken: IPasswordToken = useAppSelector(state => state.session.passwordTokens[token.current]);
  const navigate = useNavigate();
  const session: ISessionReducer = useSelector(selectSession);

  const enabled = validateEmail(email);

  const emailChanged = e => {
    setInvalid(false);
    setEmail(e);
  };

  const submit = e => {
    if (!enabled) {
      setInvalid(true);
      return;
    }

    dispatch(forgotRequest({ email, token: token.current }));
  };

  useEffect(() => {
    //   if (passwordToken && passwordToken.saving === SavingState.SAVED)
  }, [passwordToken]);

  const getMessage = () => {
    switch (passwordToken.saving) {
      case SavingState.SAVING:
        return <LoadingSpinner />;
      case SavingState.ERROR:
        return <span>Password reset failed</span>;
      case SavingState.SAVED:
        return (
          <>
            <h2 className="mt-6 mb-2 text-center text-xl">
              Check your email, we have sent you a message with a magic link to change your password
            </h2>
            <div></div>
          </>
        );
    }
  };

  return (
    <div className="mt-10 flex items-center justify-center ">
      <div className="max-w-md w-full space-y-8">
        <div className={'bg-white dark:bg-howio-900 dark:text-white py-8 lg:px-10 px-6 shadow-xl rounded-lg'}>
          <div className="sm:mx-auto sm:w-full sm:max-w-md mb-5">
            <img
              className="mx-auto h-12 w-auto"
              src={session.config?.logo ? `/${session.config.logo}` : '/howio-logo-wht.svg'}
              alt="HowIO Logo"
            />
          </div>
          {!passwordToken ? (
            <>
              <h2 className="mt-6 mb-2 text-center text-xl ">Please enter your email</h2>
              <div>
                <div className={invalid ? 'shake input-invalid mb-8' : 'mb-8'}>
                  <div className="mt-1">
                    <TextInput
                      name="email"
                      type="email"
                      autoComplete="email"
                      value={email}
                      onChange={e => emailChanged(e)}
                      required={true}
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-center">
                <PrimaryButton
                  className="w-full bg-brand h-12 text-white"
                  onClick={submit}
                  label={'Submit'}
                ></PrimaryButton>
              </div>
            </>
          ) : (
            <div className="flex justify-center h-40">{getMessage()}</div>
          )}
        </div>
      </div>
    </div>
  );
}
